/** هم‌تراز با MehrsanProcessType در API */
export const MEHRSAN_PROCESS_TYPES = [
  { value: 1, label: "قرارداد خرید برق" },
  { value: 2, label: "تکمیل اطلاعات احداث" },
  { value: 3, label: "ثبت اطلاعات پس از احداث" },
  { value: 4, label: "پروانه بهره‌برداری" },
  { value: 5, label: "اطلاعات تولید" },
  { value: 6, label: "قبض تولید" },
  { value: 7, label: "مدارک نهایی ساتبا/مهرسان" },
  { value: 99, label: "سایر" },
];

export const MEHRSAN_PROCESS_TYPE_OTHER = 99;
export const MEHRSAN_PROCESS_TYPE_POWER_PURCHASE = 1;

/** هم‌تراز با MehrsanProcessStatus در API */
export const MEHRSAN_STATUS_COMPLETED = 4;
export const MEHRSAN_STATUS_CANCELLED = 5;
export const MEHRSAN_STATUS_FINAL_STAGE = 6;

export const MEHRSAN_PROCESS_STATUSES = [
  { value: 0, label: "پیش‌نویس" },
  { value: 1, label: "در حال پیگیری" },
  { value: 2, label: "در انتظار پاسخ مهرسان" },
  { value: 3, label: "نیاز به اصلاح" },
  { value: 4, label: "تکمیل شده" },
  { value: 5, label: "لغو شده" },
  { value: 6, label: "مرحله پایانی" },
  { value: 99, label: "سایر" },
];

/** وضعیت‌های میانی برای بروزرسانی روزانه */
export const MEHRSAN_FOLLOW_UP_STATUSES = MEHRSAN_PROCESS_STATUSES.filter(
  (s) =>
    ![
      MEHRSAN_STATUS_COMPLETED,
      MEHRSAN_STATUS_CANCELLED,
      MEHRSAN_STATUS_FINAL_STAGE,
      99,
    ].includes(s.value)
);

/** فقط workspace مرکز پرونده اپراتور/مدیریت */
export const isCaseWorkspaceOperationsApi = (detailApi) =>
  typeof detailApi === "string" &&
  (detailApi.includes("/Management/") ||
    detailApi.includes("/SolarentOperator/"));

export const resolveOperationsSource = (detailApi) =>
  typeof detailApi === "string" && detailApi.includes("Management")
    ? "Management"
    : "SolarentOperator";

export const shouldShowMehrsanTab = isCaseWorkspaceOperationsApi;

export const getStatusChipColor = (status) => {
  const s = Number(status);
  if (Number.isNaN(s)) return "default";
  if (s === 4) return "success";
  if (s === 6) return "warning";
  if (s === 2 || s === 3) return "warning";
  if (s === 5) return "error";
  return "default";
};
